<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-card class="elevation-6">
            <v-card-text>
                <v-toolbar flat color="white">
                <v-toolbar-title v-if="!newBook">
                    Πεδίο Επεξεργασίας
                    <v-icon v-if="finalizedByPublisher" color="green" class="mr-3">info</v-icon>
                    <v-tooltip left v-if="Object.keys($store.getters.editPublisherBook).length && !finalizedByPublisher">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="red" class="mr-3" v-on="on">info</v-icon>
                        </template>
                        <span>
                            Δεν έχει ολοκληρωθεί η εγγραφή του συγγράμματος βάσει Κ.Υ.Α. 80748/Ζ1 08.07.2022.<br>
                            Για να είναι το σύγγραμμα επιλέξιμο από τις γραμματείες, θα πρέπει να έχει συμπληρωμένα <br>
                            όλα τα υποχρεωτικά του πεδία, να έχουν αναρτηθεί τα αρχεία του βιβλίου, να έχει κοστολογηθεί <br>
                            ηλεκτρονικά (ή να έχει λάβει τιμή από την Επιτροπή Κοστολόγησης) και να είναι ενεργό.
                        </span>
                    </v-tooltip>
                </v-toolbar-title>

                <v-toolbar-title v-else>
                    Προσθήκη Νέου Συγγράμματος
                </v-toolbar-title>

                    <v-spacer></v-spacer>
<!--<v-speed-dial v-if="!newBook && !disableAllFields && (groupBooksSize == 0 || (finalizedByPublisher && nextEditionId == null))"-->
                    <v-speed-dial v-if="!newBook && !disableAllFields && (groupBooksSize == 0 || (finalizedByPublisher && nextEditionId == null))"
                                  class="mb-8"
                                  color="primary" dark fab top right
                                  direction="left"
                                  open-on-hover
                                  v-model="fab">
                        <template v-slot:activator>
                            <v-btn small
                                    color="primary"
                                    dark
                                    fab
                                    v-model="fab">
                                <v-icon v-if="fab">mdi-close</v-icon>
                                <v-icon v-else>add</v-icon>
                            </v-btn>
                        </template>
                        <v-tooltip top v-if="groupBooksSize == 0">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on"
                                       color="primary"
                                       @click="addNewVolume"
                                       dark
                                       fab
                                       small>
                                    <v-icon>description</v-icon>
                                </v-btn>
                            </template>
                            <span>Προσθήκη Τόμου</span>
                        </v-tooltip>
                        <v-tooltip top v-if="finalizedByPublisher && nextEditionId == null">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on"
                                       color="primary"
                                       @click="addNewBookEdition"
                                       dark
                                       fab
                                       small>
                                    <v-icon>note_add</v-icon>
                                </v-btn>
                            </template>
                            <span>Προσθήκη Νέας Έκδοσης</span>
                        </v-tooltip>
                    </v-speed-dial>

                    <v-tooltip top v-if="previousEditionId != null">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small fab color="primary" v-on="on" @click="goToAnotherEdition(previousEditionId)"><v-icon>arrow_back_ios</v-icon></v-btn>
                        </template>
                        <span>Προηγούμενη Έκδοση</span>
                    </v-tooltip>

                    <v-tooltip top v-if="nextEditionId != null">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small fab color="primary" v-on="on" @click="goToAnotherEdition(nextEditionId)"><v-icon>arrow_forward_ios</v-icon></v-btn>
                        </template>
                        <span>Επόμενη Έκδοση</span>
                    </v-tooltip>
                </v-toolbar>

                <v-divider></v-divider>
                    <v-row class="pb-0 justify-center">
                      <v-col cols="12">
						  <v-form v-model="valid" ref="form">

							  <v-row>
								  <v-col cols="2" style="max-height: 65px">
									  <v-tooltip left color="info">
										  <template v-slot:activator="{ on, attrs }">
											  <v-btn @click="checkOsdelApi" :disabled="disableAllFields || isbnLengthValidator !== true" outlined color="primary" v-on="on" max-width="60px">
												  <v-icon size="20" class="mx-0 px-0" color="primary">mdi-database</v-icon>
												  <v-icon size="15" class="mx-0 px-0" color="primary">mdi-arrow-right</v-icon>
												  <v-icon size="20" class="mx-0 px-0" color="primary">mdi-book-open-variant</v-icon>
											  </v-btn>
										  </template>
										  <div style="width: 350px !important;">
											  <span style="color: black; font-size: 18px">
											     Συγχρονισμός/Ενημέρωση στοιχείων από ΟΣΔΕΛ
											  </span>
										  </div>
									  </v-tooltip>
								  </v-col>

								  <v-col cols="4" style="max-height: 65px">
									  <v-select
										  :items="isbnNumberOfDigitsSelector"
										  item-text="label"
										  label="Ψηφία ISBN"
										  @change="checkIsbnAfterSelector($event)"
										  outlined
										  dense
										  return-object
										  v-model="isbnDigitsSelect">
									  </v-select>
								  </v-col>
								  <v-col cols="6" style="max-height: 65px">
									  <v-text-field
										  :readonly="disableAllFields"
										  :rules="[isRequired,isbnLengthValidator]"
										  dense
										  label="ISBN"
										  outlined
										  required
										  @blur="isbnWarning"
										  v-model="isbn"
									  ></v-text-field>
								  </v-col>
							  </v-row>

                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields ? true : groupBooksSize > 0 ? true: false"
                                  :rules="[stringLengthValidationWithRequired(title,512)]"
                                  dense
                                  label="Τίτλος"
                                  outlined
                                  v-model="title"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields"
                                  :rules="[stringLengthValidation(subtitle,2048)]"
                                  dense
                                  label="Υπότιτλος"
                                  outlined
                                  required
                                  v-model="subtitle"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row align="center">
                            <v-col  style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields ? true : groupBooksSize > 0 ? true: false"
                                  :rules="[stringLengthValidationWithRequired(authors,1024)]"
                                  dense
                                  label="Συγγραφείς"
                                  outlined
                                  v-model="authors"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px">
                                <v-text-field
                                        :readonly="disableAllFields"
                                        :rules="[stringLengthValidationWithRequired(publisherName,255)]"
                                        dense
                                        label="Εκδόσεις"
                                        outlined
                                        required
                                        v-model="publisherName"
                                ></v-text-field>
                            </v-col>
                          </v-row>


                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-select :readonly="disableAllFields"
                                        :items="bookBinding"
                                        :rules="[isRequiredForSelectors('bookBinding')]"
                                        dense
                                        item-text="label"
                                        label="Κατάσταση Βιβλιοδεσίας"
                                        outlined
                                        return-object
                                        v-model="bookBindingSelect"
                              ></v-select>
                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields"
                                  :rules="[stringLengthValidationWithRequired(linkToPublisher,4096)]"
                                  dense
                                  label="Ιστοσελίδα Συγγράμματος"
                                  outlined
                                  required
                                  v-model="linkToPublisher"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  readonly
                                  dense
                                  label="Αριθμός Σελίδων"
                                  outlined
                                  placeholder="Αυτόματη Συμπλήρωση"
                                  required
                                  v-model="pages"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields ? true : groupBooksSize > 0 ? true: false"
                                  :rules="[stringLengthValidationWithRequired(editionNumber,255)]"
                                  dense
                                  label="Αριθμός Έκδοσης"
                                  outlined
                                  required
                                  v-model="editionNumber"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px" v-if="hasMoreVolumes">
                              <v-text-field
                                  :readonly="disableAllFields"
                                  :rules="[volumeTitleRequired]"
                                  :error="volumeNumber===null || volumeNumber===''"
                                  dense
                                  label="Τόμος"
                                  outlined
                                  required
                                  v-model="volumeNumber"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields"
                                  :rules="Number(firstPublicationYear) <= getYear() ? yearNumberValidation : yearValidation"
                                  dense
                                  label="Έτος Πρώτης Έκδοσης"
                                  outlined
                                  required
                                  v-model="firstPublicationYear"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :readonly="disableAllFields"
                                  :rules="Number(publicationYear) <= getYear() ? yearNumberValidation : yearValidation"
                                  dense
                                  label="Έτος Τρέχουσας Έκδοσης"
                                  outlined
                                  required
                                  v-model="publicationYear"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="max-height: 65px">
                                <v-select :readonly="disableAllFields"
                                          :items="firstPostYearItems"
                                          :rules="[isRequiredForSelectors('firstPostYearItems')]"
                                          dense item-value="year"
                                          :item-text="item => `${item.year}-${Number(item.year) + 1}`"
                                          label="Έτος Πρώτης Ανάρτησης"
                                          outlined
                                          v-model="selectFirstPostingYear"
                                ></v-select>
                            </v-col>
                            <v-col style="max-height: 65px">
                                <v-text-field
                                        :readonly="disableAllFields"
                                        :rules="[stringLengthValidation(reprintPublicationComments,255)]"
                                        dense
                                        label="Σχόλια Επανατύπωσης"
                                        outlined
                                        v-model="reprintPublicationComments"
                                ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  readonly
                                  dense
                                  label="Τιμή Κοστολόγησης"
                                  outlined
                                  required
                                  placeholder="Αυτόματη Συμπλήρωση"
                                  v-model="suggestedPrice"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  :disabled="disableAllFields"
                                  :rules="[...priceValidation,numberUpperThresholdValidation(tradePrice,1000)]"
                                  dense
                                  label="Τιμή Εμπορίου"
                                  outlined
                                  required
                                  v-model="tradePrice"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  disabled
                                  dense
                                  label="Εγκριθείσα Τιμή"
                                  outlined
                                  v-model="price"
                              ></v-text-field>
                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-text-field
                                  disabled
                                  dense
                                  label="Αρ. Απόφ. Κοστολόγησης"
                                  outlined
                                  v-model="decisionNumber"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col style="max-height: 65px">
                              <v-tooltip bottom color="info" >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      dense readonly
                                      label="Σχόλιο Κοστολόγησης"
                                      outlined
                                      :value="priceComments">
                                    <template v-slot:append>
                                      <v-icon v-on="on">search</v-icon>
                                    </template>
                                  </v-text-field>
                                </template>
                                <div style="width: 350px !important;">
                                  <span style="color: black; font-size: 20px"> Σχόλιο Κοστολόγησης: <br/>{{ priceComments }}</span>
                                </div>
                              </v-tooltip>

                            </v-col>
                            <v-col style="max-height: 65px">
                              <v-checkbox
                                  class="mt-0"
                                  disabled
                                  color="primary"
                                  label="Ελεγμένο από επιτροπή"
                                  v-model="checkedPrice"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-btn :disabled="false"
                                     @click="openKeyWordsModal"
                                     block
                                     style="text-transform: none !important;"
                                     color="primary"
                                     outlined
                                     text>Λέξεις Κλειδιά
                              </v-btn>
                            </v-col>
                            <v-col>
                              <v-btn :disabled="false"
                                     style="text-transform: none !important;"
                                     @click="openBookFilesModal" block :color="bookFilesUploaded? 'lightSeaGreen' :'orange'"
                                     outlined >Αρχεία Βιβλίου
                                  <v-icon class="pl-2" v-if="bookFilesUploaded" >mdi-check-all</v-icon>
                                  <v-icon class="pl-2" v-else>mdi-alert-circle-outline</v-icon>
                              </v-btn>
                            </v-col>
                            <!--<v-col>-->
                            <!--<v-btn :disabled="disableAllFields ? true : (newBook ? true : hasMoreVolumes ? false : true)"-->
                            <!--@click="openBookVolumeModal" block color="primary" outlined text>Τόμοι-->
                            <!--</v-btn>-->
                            <!--</v-col>-->
                          </v-row>

                          <v-row align="center">
                            <v-col class="pt-0 pb-0">
                                <v-checkbox
                                        :disabled="disableAllFields ? true : $store.getters.editPublisherBook.masterVolumeId!= $store.getters.editPublisherBook.id ? true : groupBooksSize > 0 ? true : false"
                                        class="mb-1"
                                        color="primary"
                                        label="Αποτελεί τόμο"
                                        v-model="hasMoreVolumes"
                                ></v-checkbox>
                            </v-col>
                            <v-col class="pt-0 pb-0">
                              <v-checkbox
                                  :disabled="disableAllFields"
                                  class="mb-1"
                                  color="primary"
                                  label="Έχει προκύψει από κατάτμηση ενιαίου συγγράμματος"
                                  v-model="separatedBook"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
<!--                          <v-row align="center">-->
<!--                            <v-col class="pt-0">-->
<!--                                <v-checkbox-->
<!--                                        :readonly="disableAllFields"-->
<!--                                        :label="active ? 'Ενεργό' : 'Ανενεργό' "-->
<!--                                        class="mb-1"-->
<!--                                        color="primary"-->
<!--                                        v-model="active"-->
<!--                                ></v-checkbox>-->
<!--                            </v-col>-->
<!--                            <v-col class="pt-0">-->
<!--                              <v-checkbox v-show="false"-->
<!--                                  :disabled="disableAllFields"-->
<!--                                  class="mb-1"-->
<!--                                  color="primary"-->
<!--                                  label="Διαστάσεις κατά προσέγγιση"-->
<!--                                  v-model="approximateDimensions"-->
<!--                              ></v-checkbox>-->
<!--                            </v-col>-->
<!--                          </v-row>-->
                        </v-form>
                      </v-col>
                    </v-row>

              <v-row>
                <v-col class="pt-0 pb-0">
                  <v-btn  style="font-size: 17px"
                         block color="info" @click="openPricing" >
                      ΚΟΣΤΟΛΟΓΗΣΗ
                      <v-icon class="pl-1">euro</v-icon>
                  </v-btn>
                </v-col>
                <v-col class="pt-0 pb-0">
                  <v-btn block @click="openPricingHistoryDialog" style="font-size: 17px" >
                      ΙΣΤΟΡΙΚΟ ΚΟΣΤΟΛΟΓΗΣΗΣ
                      <v-icon class="pl-1" >history</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn :disabled="disableAllFields ? true : valid ? false : true" @click="save()" block color="primary">ΑΠΟΘΗΚΕΥΣΗ</v-btn>
                </v-col>
              </v-row>
            </v-card-text>
        </v-card>

        <v-dialog
                max-width="500"
                v-model="dialog">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Λέξεις κλειδιά
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-row>
                        <v-col cols="9">
                            <v-text-field
                                    label="Λέξεις κλειδιά"
                                    outlined
                                    v-model="keyWordsFied"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-btn  :disabled="disableAllFields"
                                    @click="saveKeyWord()"
                                    color="primary" fab>
                                <v-icon class="text--white">save</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-data-table
                            :headers="headers"
                            :items="keywords"
                            class="elevation-6"
                            no-data-text="Δεν υπάρχουν δεδομένα."
                    >
                        <template v-slot:item="{ item }">

                            <tr>
                                <td class="text-xs-right">{{ item }}</td>
                                <td class="text-xs-right">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon :disabled="disableAllFields"
                                                    v-on="on"
                                                    @click="deleteKeyWord(item)"
                                                    color="red">delete</v-icon>
                                        </template>
                                        <span>Διαγραφή</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            @click="dialog = false"
                            color="primary"
                            text>
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <BookFiles
                :disableAllFields="disableAllFields"
                :pathToCover="pathToCover"
                :pathToBackcover="pathToBackcover"
                :pathToTOC="pathToTOC"
                :pathToChapter="pathToChapter"
                :bookId="id"
        />

        <PricingModal :key="pricingModalKey" :opened-as-history="openPricingDialogAsHistory" :pricing-obj="pricingObjForPricingDialog" :selected-book-id="id" :book-title="title"/>
        <!--<BookVolume :disableAllFields="disableAllFields" :volumeNumber="volumeNumber" :volumeTitle="volumeTitle"/>-->
        <ConfirmationDialog event-name="ConfirmForSaveAtBookEdit" :main-text="confirmationText"/>
        <PricingHistoryDialog :selected-book-id="id" :book-title="title" :key="pricingHistoryDialogKey"/>
    </div>
</template>

<script>

    import {eventBus} from "../../main";
    import request, {BASE_URL} from "../../requests"
    import utils from "../../utilities"
    import BookFiles from "./BookFiles";
    import BookVolume from "./BookVolume";
    import ConfirmationDialog from "../ConfirmationDialog";
    import PricingModal from "./pricing/PricingModal";
    import PricingHistoryDialog from "./pricing/PricingHistoryDialog";
    import requests from "../../requests";
    import axios from "axios";
    import properties from "../../properties";
    import store from "../../store";

    export default {
        name: "BookEdit",
        components: {BookVolume, BookFiles, ConfirmationDialog, PricingModal, PricingHistoryDialog},
        data: () => ({
          customTooltip:false,
            pricingObjForPricingDialog: {},
            pricingHistoryDialogKey:0,
            openPricingDialogAsHistory:false,
            confirmationText: '',
            fab: false,
            nextEdition: false,
            valid: false,
            bookFileDialog: false,
            dialog: false,
            id: 0,
            keyWordsFied: '',
            keywords: [],
            bookFilesUploaded:false,
            newBook: false,
            utils,
            disableAllFields: true,
            title: '',
            active: false,
            subtitle: '',
            distributionType: 0,
            reprintPublicationComments: '',
            approximateDimensions: false,
            separatedBook: false,
            hasMoreVolumes: false,
            authors: '',
            isbn: '',
            ebookIsbn: '',
            publisherName: '',
            bookBinding: [
                {id: 1, label: '', value: null},
                {id: 2, label: 'Σκληρό Εξώφυλλο', value: 'Hard'},
                {id: 3, label: 'Μαλακό Εξώφυλλο', value: 'Soft'},
                {id: 4, label: 'Δερματόδετο', value: 'Leather'},
            ],
            bookBindingSelect: {},
            linkToPublisher: '',
            dimensionsOfBook: [
                {id: 1, label: '[14 x 21]'},
                {id: 2, label: '[17 x 24]'},
                {id: 3, label: '[21 x 29]'}
            ],
            selectDimensionsOfBook: {},
            editionNumber: '',
            publicationYear: '',
            firstPublicationYear: '',
            firstPostYearItems: [],
            selectFirstPostingYear: {},
            pages: '',
            colorFourPages: '',
            technicalPages: '',
            typeOfBook: [
                {id: 1, label: '', value: null},
                {id: 2, label: 'Απλό', value: 'SIMPLE'},
                {id: 3, label: 'Τεχνικό', value: 'TECHNICAL'},
            ],
            isbnDigitsSelect:{label: '8-ψήφιο', value: 8},
            isbnNumberOfDigitsSelector: [
                {label: '8-ψήφιο', value: 8},
                {label: '10-ψήφιο', value: 10},
                {label: '13-ψήφιο', value: 13},
                {label: 'Άλλο', value: 0},
            ],
            cancelIsbnWarning:false,
            typeOfBookSelected: {},
            suggestedPrice: '',
            price: '',
            tradePrice: '',
            decisionNumber: '',
            checkedPrice: false,
            priceComments: '',
            pathToCover: '',
            pathToBackcover: '',
            pathToTOC: '',
            pathToChapter: '',
            pathToCoverValue: null,
            pathToBackcoverValue: '',
            pathToTOCValue: '',
            pathToChapterValue: '',
            volumeNumber: null,
            volumeTitle: '',
            groupBooksSize: 0,
            finalizedByPublisher: false,
            nextEditionId: null,
            previousEditionId: null,
            pricingModalKey: 10000,
            isRequired: [v => !!v || "Το πεδίο είναι Υποχρεωτικό"],
            isNotRequired: [v => true || ""],
            isPositive: [
                v => /^\s*[0-9][0-9 ]*$/.test(v) || "Το πεδίο είναι Υποχρεωτικό",
                // v => !!v || "Το πεδίο είναι Υποχρεωτικό",
                v => /^(^[0-9]\d*$)$/.test(v) || "Θετικός ακέραιος αριθμός"
            ],
            priceValidation: [
                v => !!v || "Το πεδίο είναι Υποχρεωτικό",
                v => /^(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/.test(v) || "Η τιμή δεν είναι αποδεκτή"
            ],
            numberOfPagesValidation: [
                v => false || "Μικρότερο από το συνολικό Αριθμό σελίδων του βιβλίου"
            ],
            urlValidation: [
                v => !!v || "Το πεδίο είναι Υποχρεωτικό",
                v => /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(v) || "Το πεδίο δεν είναι έγκυρο"
            ],
            yearValidation: [
                v => false || "Μικρότερο ή ίσο του επόμενου έτους",
            ],
            yearNumberValidation: [
                v => !!v || "Το πεδίο είναι Υποχρεωτικό",
                v => /^(19|20)[0-9]{2}$/.test(v) || "Το Έτος δεν είναι Αποδεκτό"],

            headers: [
                {
                    text: 'Λέξεις κλειδιά',
                    align: 'start',
                    sortable: false
                },
                { text: 'Ενέργεις', value: 'calories', sortable: false },
            ],

        }),

        computed:{

            isbnLengthValidator(){
                if(this.isbn!== undefined){
                    if(!this.isbn.toString().match(/^([^a-zA-Zα-ωΑ-Ω ][0-9]*[X]?|[M][0-9]*)$/)){
                        this.cancelIsbnWarning = true;
                        return 'Το πεδίο αποτελείται μόνο από αριθμούς εκτός αν αρχίζει από αγγλικό \'M\' ή αν το τελευταίο ψηφίο είναι αγγλικό \'Χ\'.';
                    }
                    if(this.isbn.length!=parseInt(this.isbnDigitsSelect.value)){
                        this.cancelIsbnWarning = true;
                        return 'Λάθος αριθμός ψηφίων.';
                    }else if((this.isbn.toString().startsWith('M') || this.isbn.toString().startsWith('m')) && this.isbn.toString().length!=10){
                        this.cancelIsbnWarning = true;
                        return 'Μόνο τα 10-ψήφια isbn μπορούν να ξεκινάνε απο M.'
                    }else if(this.isbn.length== 13 && parseInt(this.isbnDigitsSelect.value)==13 && !(this.isbn.toString().startsWith('978') || this.isbn.toString().startsWith('9790'))){
                        this.cancelIsbnWarning = true;
                        return 'Τα 13-ψήφια isbn μπορούν να ξεκινάνε μόνο από 978 ή 9790.';
                    }else{
                        this.cancelIsbnWarning = false;
                        return true
                    }
                }

            },

            currentBookHasAllMandatoryFieldsSaved() {

                let storedBooks = this.$store.getters.publisherBooks;
                for (let i = 0; i < storedBooks.length; i++) {
                    if (this.id == storedBooks[i].id) {
                        let book = storedBooks[i];
                        if (book.authors != null && book.authors.trim().length > 0
                            && book.editorialHouse != null && book.editorialHouse.trim().length > 0
                            && book.binding != null && book.binding.trim().length > 0
                            && book.linkToPublisher != null && book.linkToPublisher.trim().length > 0
                            && book.editionNumber != null && book.editionNumber.trim().length > 0
                            && book.firstPostYear != null/* && book.firstPostYear.trim().length > 0*/
                            && book.publicationYear != null /*&& book.publicationYear.trim().length > 0*/
                            && book.firstPublicationYear != null/* && book.firstPublicationYear.trim().length > 0*/
                            && book.tradePrice != null && book.tradePrice.trim().length > 0)
                            return true;
                        else
                            return false;
                    }
                }
                return false;
            },

            step1Completed() {

              let storedBooks = this.$store.getters.publisherBooks;
              for (let i = 0; i < storedBooks.length; i++) {
                if (this.id == storedBooks[i].id) {
                    return storedBooks[i].isbn != null && storedBooks[i].isbn.trim().length > 0;
                }
              }
              return false;
            },
        },

        methods: {

          checkOsdelApi(){
	          this.$store.commit('setLoadingModal', true);

			  requests.get('rest/books/osdel/'+this.isbn, (resp)=>{
				  let respJson = JSON.parse(resp)
				  // console.log(respJson.response.docs[0].product_kind);
				  if (respJson.response.numFound == 1 && respJson.response.docs[0].product_kind === 'Βιβλίο') {
					  console.log('1');
					  let bookResult = respJson.response.docs[0];
					  let authorsText = '';
					  console.log(bookResult);
					  this.publisherName = bookResult.imprint;
					  this.title = bookResult.distinctive_title;
					  this.subtitle = bookResult.distinctive_subtitle;
					  this.tradePrice = bookResult.price;
					  this.publicationYear = bookResult.pub_year;


					  bookResult.contr_name.forEach((author, index, array) => {
						  authorsText += author.replace(/,/g, '');
						  if (index !== array.length - 1) {
							  authorsText += ', ';
						  }
					  });
					  this.authors = authorsText;
				  } else {
					  utils.setErrorPopup("Δεν εντοπίστηκαν κατάλληλα αποτελέσματα με το εν λόγω ISBN, παρακαλούμε όπως συμπληρώσετε τα πεδία χειροκίνητα");
				  }

				  this.$store.commit('setLoadingModal', false);
			  })

          },

            openPricingHistoryDialog(){
                if (this.id && this.title) {
                    this.pricingHistoryDialogKey++;
                    this.$store.commit('setPricingHistory', true);
                }else{
                    utils.setErrorPopup("Παρακαλώ επιλέξτε βιβλίο");
                }
            },

            openPricing() {

                if (this.id && this.title) {
                    if (this.currentBookHasAllMandatoryFieldsSaved) {
                        this.$store.commit('setLoadingModal', true);
                        request.getBookPricingInfo(utils.getLocalStorage('token'), this.id, this.getBookPricingInfoCallback);
                    }
                    else
                        utils.setErrorPopup('Για την κοστολόγηση του συγγράμματος είναι υποχρεωτική η καταχώριση όλων των απαραίτητων πεδίων του συγγράμματος.');
                }else{
                    utils.setErrorPopup("Παρακαλώ επιλέξτε βιβλίο");
                }
            },

            getBookPricingInfoCallback(response) {
                if (!response)
                  this.pricingObjForPricingDialog = {};
                else
                  this.pricingObjForPricingDialog = JSON.parse(JSON.stringify(response));

                this.pricingModalKey++;
                this.openPricingDialogAsHistory = false;
                this.$store.commit('setPricingModal', true);
                this.$store.commit('setLoadingModal', false);
            },

            openPricingFromHistory(item){ // emit from PricingHistoryDialog
                this.pricingObjForPricingDialog = JSON.parse(JSON.stringify(item));
                this.openPricingDialogAsHistory = true;
                this.pricingModalKey++;
                this.$store.commit('setPricingModal', true);
            },

            getYear(){
                var date = new Date();
                return date.getFullYear() + 1
            },
            // add new Volume in current Book
            addNewVolume(){

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    var masterVolumeId = this.$store.getters.editPublisherBook.masterVolumeId;
                    request.addVolume(token, masterVolumeId, this.addVolumeCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            addVolumeCallBack(response){

                this.$store.commit('setEditPublisherBook', response.newBook);
                this.$store.commit('setPublisherBooks', response.listOfAllBooks);
                this.createEditFields(true);
                this.$store.commit('setLoadingModal', false);
            },

            //add new Book Edition
            addNewBookEdition() {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    var selectedBookId = this.$store.getters.editPublisherBook.id;
                    request.addEdition(token, selectedBookId, this.addVolumeCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            // go to another volume next or previous
            goToAnotherEdition(bookId) {

                var book = this.$store.getters.publisherBooks;

                for (var i = 0; i < book.length; i++) {
                    if (book[i].id == Number(bookId)){
                        this.$store.commit('setEditPublisherBook', book[i]);
                        eventBus.$emit('specialEventName',book[i].id);
                        this.createEditFields(true);
                    }
                }
            },

            //open the Book files Modal
            openBookFilesModal() {
                this.$store.commit('setBookFileModal', true);
            },

            //open Volume Book modal
            openBookVolumeModal() {
                eventBus.$emit('fillTheField', this.volumeNumber, this.volumeTitle);
                this.$store.commit('setBookVolumeModal', true);

            },

            openKeyWordsModal() {

                this.dialog = true;
            },

            deleteKeyWord(word) {

                for (var i = 0; i < this.keywords.length; i++) {
                    if (this.keywords[i] == word) {
                        this.keywords.splice(i, 1);
                        return;
                    }
                }
            },

            saveKeyWord() {
                if (this.keywords != undefined && this.keywords != null && this.keyWordsFied != '') {
                    for (var i = 0; i < this.keywords.length; i++) {
                        if (this.keywords[i] == this.keyWordsFied)
                            return
                    }
                    this.keywords.push(this.keyWordsFied);
                    this.keyWordsFied = ''
                }
                else {
                    if (this.keyWordsFied != '') {
                        this.keywords = [];
                        this.keywords.push(this.keyWordsFied);
                        this.keyWordsFied = '';
                    }
                }
            },

            confirmSave(){
                this.confirmationText = 'Έχετε επιλέξει ηλεκτρονική δίαθεση για το παραπάνω σύγγραμα και θα μεταφερθείτε στην Βιβλιοθήκη Ηλεκτρονικών Συγγραμμάτων. Τα στοιχεία του βιβλίου θα' +
                    ' σταλθούν παράλληλα και από το Π.Σ. Εύδοξος όπως είναι αποθηκευμένα. Εάν έχετε πραγματοποιήσει αλλαγές στη φόρμα βιβλίου πατήστε αποθήκευση πρώτα. Επιθυμείτε να συνεχίσετε?';
                this.$store.commit('setConfirmModal', true);
            },

            sendBookInfoToQnR(type){ //type will be PDF or E-PUB
                console.log(type);
                this.$store.commit('setLoadingModal', true);
                request.uploadBookToBookstore(this.$store.getters.editPublisherBook.id, type, this.sendBookInfoToQnRCallBack);
            },

            sendBookInfoToQnRCallBack(response){
                utils.setLocalStorage('redirectSent', true);
                utils.setLocalStorage('academicYears', this.$store.getters.academicYears); // firstPostYear (book field) doesn't work after redirect we need to keep this object in memory
                utils.setLocalStorage('academicYearsFixed', this.$store.getters.yearsFixed); // firstPostYear (book field) doesn't work after redirect we need to keep this object in memory
                this.$store.commit('setLoadingModal', false);
                window.open(response.redirectUrl,"_self");
            },

            //    save the Book
            save() {
                var book = this.createBookObject();
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.editBook(token, book, this.editBookCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }

            },

            editBookCallBack(response) {
                for(let bookObj in response){
                    if(response[bookObj].hasOwnProperty('id')) {
                        if (response[bookObj].id === this.id) {
                            this.$store.commit('setEditPublisherBook', response[bookObj]);
                            break;
                        }
                    }
                }
                this.$store.commit('setPublisherBooks', response);
                this.createEditFields(true); // this and loop above will refresh the bookEdit fields
                this.$store.commit('setLoadingModal', false);
            },

            //create the book Object to pass in request
            createBookObject() {

                var book = JSON.parse(JSON.stringify(this.$store.getters.editPublisherBook));

                book.title = this.title;
                book.subtitle = this.subtitle;
                book.authors = this.authors;
                //book.active = this.active;
                book.isbn = this.isbn;
                book.ebookIsbn = this.ebookIsbn;
                book.distributionType = this.distributionType;
                book.editorialHouse = this.publisherName;
                book.linkToPublisher = this.linkToPublisher;
                book.editionNumber = this.editionNumber;
                book.publicationYear = this.publicationYear;
                book.firstPublicationYear = this.firstPublicationYear;
                book.pages = this.pages;
                book.colorFourPages = this.colorFourPages;
                book.technicalPages = this.technicalPages;
                book.price = this.price;
                book.suggestedPrice = this.suggestedPrice;
                book.tradePrice = this.tradePrice;
                book.checkedPrice = this.checkedPrice;
                book.decisionNumber = this.decisionNumber;
                book.priceComments = this.priceComments;
                book.binding = this.bookBindingSelect.value;
                book.distributionType = this.distributionType;
                book.keywords = this.keywords;
                book.volumeNumber = this.volumeNumber;
                book.reprintPublicationComments = this.reprintPublicationComments;
                book.approximateDimensions = this.approximateDimensions;
                book.separatedBook = this.separatedBook;
                book.hasMoreVolumes = this.hasMoreVolumes;
                // var firstYear = this.selectFirstPostingYear.label.split(" - ");
                // if (firstYear[0] == '') {
                //     book.firstPostYear = null;
                // } else {
                //     book.firstPostYear = parseInt(firstYear[0]);
                // }
                book.firstPostYear = this.selectFirstPostingYear
                book.technicalType = this.typeOfBookSelected.value;
                //check box
                //book.active = this.checkTheCheckBox(this.active);
                book.separatedBook = this.checkTheCheckBox(this.separatedBook);
                book.hasMoreVolumes = this.checkTheCheckBox(this.hasMoreVolumes);
                book.approximateDimensions = this.checkTheCheckBox(this.approximateDimensions);
                return book;
            },

            // check the checkBox and return true/false
            checkTheCheckBox(checkBox){

                if (checkBox == undefined || checkBox == null) {
                    return false
                }
                return checkBox;
            },

            //    create the edit Fields
            createEditFields(show) {

                if (this.newBook && !show) {
                    var data = {}
                }
                else {
                    var data = this.$store.getters.editPublisherBook;
                }

                this.title = data.title;
                this.id = data.id;
                this.subtitle = data.subtitle;
                this.authors = data.authors;
                this.active = data.active;
                if(data.isbn) {

                    this.isbn = data.isbn.toString();

                    var isbnLength = this.isbn.length;
                    if (isbnLength == 8){
                        this.isbnDigitsSelect = this.isbnNumberOfDigitsSelector[0];
                    }else if (isbnLength == 10){
                        this.isbnDigitsSelect = this.isbnNumberOfDigitsSelector[1];
                    }else if (isbnLength == 13){
                        this.isbnDigitsSelect = this.isbnNumberOfDigitsSelector[2];
                    }else {
                        this.isbnDigitsSelect = this.isbnNumberOfDigitsSelector[3];
                    }
                }else{
                    this.isbn = '';
                    this.isbnDigitsSelect = this.isbnNumberOfDigitsSelector[3];
                }
                this.ebookIsbn = data.ebookIsbn;
                this.distributionType = data.distributionType;
                this.publisherName = data.editorialHouse;
                this.linkToPublisher = data.linkToPublisher;
                this.editionNumber = data.editionNumber;
                this.publicationYear = data.publicationYear;
                this.pages = data.pages;
                this.colorFourPages = data.colorFourPages;
                this.technicalPages = data.technicalPages;
                this.price = data.price;
                this.suggestedPrice = data.suggestedPrice;
                this.tradePrice = data.tradePrice;
                this.decisionNumber = data.decisionNumber;
                this.checkedPrice = data.checkedPrice;
                this.priceComments = data.priceComments;
                this.reprintPublicationComments = data.reprintPublicationComments;
                this.approximateDimensions = data.approximateDimensions;
                this.separatedBook = data.separatedBook;
                this.hasMoreVolumes = data.hasMoreVolumes;
                this.pathToCover = data.pathToCover;
                this.pathToBackcover = data.pathToBackcover;
                this.pathToTOC = data.pathToTOC;
                this.pathToChapter = data.pathToChapter;
                this.keywords = data.keywords;
                this.volumeNumber = data.volumeNumber;
                this.volumeTitle = data.volumeTitle;
                this.groupBooksSize = data.groupBooksSize;
                this.finalizedByPublisher = data.finalizedByPublisher;
                this.nextEditionId = data.nextEditionId;
                this.previousEditionId = data.previousEditionId;
                this.firstPublicationYear = data.firstPublicationYear;
                this.ebookIsbn = data.ebookIsbn;
                this.distributionType = data.distributionType;

                //create select items
                this.createBookBinding(data.binding, show);
                this.createDimensionBook(data.dimensions, show);
                this.createfirstPostingYearSelected(data.firstPostYear, show);
                this.createTypeOfBookSelected(data.technicalType, show);

                if (this.$store.getters.homePageInformation.bookAllowedPeriod) {
                    if (show) {
                        this.disableAllFields = false;
                        this.newBook = false;
                    } else {
                        if (!show && this.newBook) {
                            this.disableAllFields = false;
                        }
                        else {
                            this.disableAllFields = true;
                        }
                    }
                }
                else {
                    this.disableAllFields = true;
                }

                this.pricingObjForPricingDialog = {};
                setTimeout(() => {
                    this.$refs.form.validate();
                }, 50);
            },

            //create binding Book
            createBookBinding(binding, show) {

                if (show) {
                    if (binding == 'Soft') {
                        this.bookBindingSelect = {id: 3, label: 'Μαλακό Εξώφυλλο', value: 'Soft'}
                    } else if (binding == 'Hard') {
                        this.bookBindingSelect = {id: 2, label: 'Σκληρό Εξώφυλλο', value: 'Hard'}
                    } else if (binding == 'Leather') {
                        this.bookBindingSelect = {id: 4, label: 'Δερματόδετο', value: 'Leather'}
                    } else if (binding == 'None') {
                        this.bookBindingSelect = {id: 5, label: 'Χωρίς Εξώφυλλο', value: 'None'}
                    } else {
                        this.bookBindingSelect = {id: 1, label: '', value: null}
                    }
                } else {
                    this.bookBindingSelect = null;
                }
            },

            //create dimension of book
            createDimensionBook(dimensions, show) {

                if (show) {
                    if (dimensions == '[14 x 21]') {
                        this.selectDimensionsOfBook = {id: 1, label: '[14 x 21]'}
                    } else if (dimensions == '[17 x 24]') {
                        this.selectDimensionsOfBook = {id: 2, label: '[17 x 24]'}
                    } else if (dimensions == '[21 x 29]') {
                        this.selectDimensionsOfBook = {id: 3, label: '[21 x 29]'}
                    } else {
                        this.selectDimensionsOfBook = null
                    }
                } else {
                    this.selectDimensionsOfBook = null;
                }

            },

            //    create firstPostYearItems selected item
            createfirstPostingYearSelected(firstPostYear, show) {
                // custom fix for redirect check inside initFirstPostingYear() for more info
                if(utils.getLocalStorage('redirectSent')!=undefined){
                    if(utils.getLocalStorage('redirectSent')=== true) {
                        this.initFirstPostingYear();
                    }
                }

                if (show) {
                    this.selectFirstPostingYear = firstPostYear;
                    // for (var i = 0; i < this.firstPostYearItems.length; i++) {
                    //     var year = this.firstPostYearItems[i].label.split(" - ");
                    //     if (year[0] == firstPostYear || year[1] == firstPostYear) {
                    //         this.selectFirstPostingYear = {
                    //             id: this.firstPostYearItems[i].id,
                    //             label: this.firstPostYearItems[i].label
                    //         };
                    //         return
                    //     }
                    // }
                } else {
                    this.selectFirstPostingYear = null;
                }
            },

            //    create typeOfBookSelected item
            createTypeOfBookSelected(technicalType, show) {

                if (show) {
                    if (technicalType == "SIMPLE") {
                        this.typeOfBookSelected = {id: 2, label: 'Απλό', value: 'SIMPLE'}
                    } else if (technicalType == "TECHNICAL") {
                        this.typeOfBookSelected = {id: 3, label: 'Τεχνικό', value: 'TECHNICAL'}
                    } else {
                        this.typeOfBookSelected = {id: 1, label: '', value: null}
                    }
                } else {
                    this.typeOfBookSelected = null;
                }
            },

            //    init the firstPostYearItems select item
            initFirstPostingYear() {

                var academicYears = this.$store.getters.yearsFixed;
                console.log('academicYears');
                console.log(academicYears);

                // custom fix I am not proud of, after the redirect, firstPostYear is the only field that doesn't work
                // so we check in multiple points if redirect has happened and set the academic years obj
                // that is put in the local storage before a redirect occurs
                if(utils.getLocalStorage('redirectSent')!=undefined){
                    if(utils.getLocalStorage('redirectSent')=== true) {
                        academicYears = utils.getLocalStorage('academicYearsFixed');
                    }
                }
                this.firstPostYearItems = academicYears;

                // for(var i = 0; i < academicYears.length; i++ ) {
                //     for (var j = 0; j < academicYears.length-1; j++) {
                //         if (academicYears[j]>academicYears[j+1]) {
                //             let tmp = academicYears[j];
                //             academicYears[j] = academicYears[j+1];
                //             academicYears[j+1] = tmp
                //         }
                //     }
                // }
                //
                // var year = academicYears[academicYears.length - 1];
                // var firstYear = academicYears[0];
                // var i = 2;
                //
                //
                // for (year; year >= firstYear; year--) {
                //     this.firstPostYearItems.push(
                //         {id: i, label: year + ' - ' + parseInt(year + 1)}
                //     );
                //     i++;
                // }
            },

            //    add new Book
            addNewBook() {
                this.newBook = true;
                // this.$store.commit('setEditPublisherBook', {});
                this.createEditFields(false);
            },

            deleteItem(){

                this.newBook = false;
                this.createEditFields(false);
            },

            // Validation Functions
            // | | | | | | | | |
            // V V V V V V V V V

            stringLengthValidationWithRequired(field, length){
                if(utils.checkIfNotEmptyUndefinedOrNull(field)) {
                    if (field.toString().length > length) {
                        return 'Το πεδίο δεν μπορεί να ξεπερνά τους ' + length + ' χαρακτήρες.';
                    } else {
                        return true;
                    }
                }else{
                    return 'Το πεδίο είναι Υποχρεωτικό.';
                }
            },

            stringLengthValidation(field, length){
                if(utils.checkIfNotEmptyUndefinedOrNull(field)) {
                    if (field.toString().length > length) {
                        return 'Το πεδίο δεν μπορεί να ξεπερνά τους ' + length + ' χαρακτήρες.';
                    } else {
                        return true;
                    }
                }else{
                    return true;
                }
            },

            numberUpperThresholdValidation(field, limit){
                if(utils.checkIfNotEmptyUndefinedOrNull(field)) {
                    if(Number(field)>limit){
                        return 'Το πεδίο δεν μπορεί να είναι μεγαλύτερο από ' + limit;
                    }else {
                        return true;
                    }
                }
            },

            checkIsbnAfterSelector(selectedObj){
                if(selectedObj.value !== 0){
                    if(this.isbn.length === parseInt(selectedObj.value)){
                        this.cancelIsbnWarning = false;
                    }
                    this.isbnWarning();
                }

            },

            isbnWarning(){
                if(!this.cancelIsbnWarning){
                    var isbnAlgorithmValue=this.isbn.toString();
                    if(this.isbn.toString().startsWith('M')){
                        isbnAlgorithmValue = this.isbn.toString().replace('M', '9790')
                    }
                    if(this.isbn.toString().startsWith('m') ){
                        isbnAlgorithmValue = this.isbn.toString().replace('m', '9790')
                    }

                    var isbnCharArray=isbnAlgorithmValue.split("");
                    var digitSum=0;
                    var toggle = true
                    var checkDigit = (isbnCharArray[isbnCharArray.length-1]=== 'X' || isbnCharArray[isbnCharArray.length-1]=== 'x')? 10 : parseInt(isbnCharArray[isbnCharArray.length-1])
                    if(isbnCharArray.length==13){
                        for(var k=0;k<12;k++){
                            if(toggle){ // starting with *1
                                digitSum += parseInt(isbnCharArray[k])*1;
                            }
                            else{
                                digitSum += parseInt(isbnCharArray[k])*3;
                            }
                            toggle= !toggle;
                        }
                        if((10-(digitSum % 10) ) %10 != checkDigit){
                            alert('Το ISBN δεν είναι έγκυρης μορφής!');
                        }
                    }else if(isbnCharArray.length==10){
                        for(var k=0;k<9;k++){ // we loop until the check digit 10-1=9
                            digitSum += parseInt(isbnCharArray[k])*(10-k);

                        }
                        if((11-(digitSum % 11) )%11 != checkDigit){
                            alert('Το ISBN δεν είναι έγκυρης μορφής!');
                        }
                    }else if(isbnCharArray.length==8){
                        for(var k=0;k<7;k++){ // we loop until the check digit 8-1=7
                            digitSum += parseInt(isbnCharArray[k])*(8-k);

                        }
                        if(11-(digitSum % 11) != checkDigit){
                            alert('Το ISBN δεν είναι έγκυρης μορφής!');
                        }
                    }
                }
            },

            volumeTitleRequired(){
                if(this.volumeNumber===null || this.volumeNumber===''){
                    return 'Το πεδίο είναι Υποχρεωτικό';
                }else{
                    return true;
                }
            },

            isRequiredForSelectors(selector) {
                if(utils.checkIfNotEmptyUndefinedOrNull(selector)){
                    if(selector === 'bookBinding') {
                        if (this.bookBindingSelect.id === 1) {
                            return 'Το πεδίο είναι Υποχρεωτικό';
                        }else{
                            return true;
                        }

                    }else if(selector === 'typeOfBook') {
                        if (this.typeOfBookSelected.id === 1) {
                            return 'Το πεδίο είναι Υποχρεωτικό';
                        }else{
                            return true;
                        }
                    }
                    else if(selector === 'firstPostYearItems') {
                        if (this.selectFirstPostingYear == null ){
                            return 'Το πεδίο είναι Υποχρεωτικό';
                        }else{
                            return true;
                        }
                    }
                    else{
                        return true
                    }
                }
            },


        },

        watch:{
            'distributionType': function(){
                 setTimeout(() => {
                     this.$refs.form.validate();
                 }, 50);
            },
            '$store.getters.editPublisherBook': function(val){

                this.bookFilesUploaded = (val.pathToBackcover !== '' && val.pathToBackcover != null &&
                        val.pathToChapter !== '' && val.pathToChapter != null &&
                        val.pathToCover !== '' && val.pathToCover != null &&
                        val.pathToTOC !== '' && val.pathToTOC != null);
            },

        },

        created() {
            this.initFirstPostingYear();
            eventBus.$on('createEditFields', (show) => {
                this.createEditFields(show);
            });
            eventBus.$on('addNewBook', () => {
                this.addNewBook();
            });
            eventBus.$on('deleteItem', () => {
               this.deleteItem();
            });
            eventBus.$on('ConfirmForSaveAtBookEdit', (type) => {
               this.sendBookInfoToQnR(type);
            });
            eventBus.$on('OpenPricingDialogFromHistory', (item) => { // emit from PricingHistoryDialog
               this.openPricingFromHistory(item);
            });
        },

        beforeDestroy() {
            eventBus.$off('createEditFields');
            eventBus.$off('addNewBook');
            eventBus.$off('deleteItem');
            eventBus.$off('ConfirmForSaveAtBookEdit');
            eventBus.$off('OpenPricingDialogFromHistory');
        }
    }
</script>

<style scoped>
    .v-text-field >>> label {
        font-size: 0.9em;
    }

    .chip {
        justify-content: center;
    }

</style>